import gql from 'graphql-tag';

export const UPDATE_CCA_SETTINGS_MUTATION = gql`
  mutation UpdateCcaSettingsMutation($campaignId: ID!, $input: CampaignCcaSettingsInput!) {
    updateCcaSettings(campaignId: $campaignId, input: $input) {
      ccaSettings {
        id
        automaticCreativeCreation
        automaticApprovalRequest
        automaticApprovalRequestType
        postTextHashtagsEnabled
        postTextHashtags
        descriptionMode
        customDescription
        maxCreativesPerArticle
        leadgenFormExternalId
        leadgenCreativeCallToAction
        enableLeadgenFormNamePrefix
        leadgenFormNamePrefix
        enableLeadgenFormNameSuffix
        leadgenFormNameSuffix
        leadgenFormQueryParameters {
          key
          value
        }
      }
      errors
    }
  }
`;
